// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1214":"f1e944ca78c22ab7","2311":"5bd6999477c7afe4"}[chunkId] + ".js";
};